var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.895 4.036c0 .757-.648 1.37-1.448 1.37S2 4.793 2 4.036c0-.756.648-1.37 1.447-1.37.8 0 1.448.614 1.448 1.37M2.198 6.413h2.474V14H2.198zM8.656 6.413H6.18V14h2.475v-3.882c0-.896.302-1.797 1.509-1.797 1.364 0 1.356 1.173 1.35 2.082-.01 1.188.01 2.4.01 3.597H14V9.996c-.021-2.557-.68-3.735-2.845-3.735-1.287 0-2.084.59-2.5 1.125z",
    style: {
      fill: "#fff"
    }
  }));
};
export default SvgLinkedin;